import { useStore } from '../../../../../../models'
import { Section } from './Section'
import { DS } from '../../../../../../design-system'

export const Info = () => {
  const {
    game: { biggestBet, myPlayer }
  } = useStore()

  return (
    <DS.Frame row justifyContent="space-around">
      <Section title="Current Bet" value={biggestBet ?? 0} />
      <Section title="Your chips" value={myPlayer?.chips ?? 0} showChip />
    </DS.Frame>
  )
}
